import { useEffect } from 'react';

// Global flag to ensure script only loads once
let scriptLoaded = false;
let scriptElement: HTMLScriptElement | null = null;

const useAirtimeScript = (url: string, token: string) => {
    useEffect(() => {
        // Initialize airtime config
        window.airtime = window.airtime || { id: token };

        // Check if custom element is already defined (most reliable check)
        if (customElements.get('airtime-widget')) {
            scriptLoaded = true;
            return;
        }

        // Check if script is already loaded or being loaded
        if (scriptLoaded) {
            return;
        }

        // Check if script element already exists in DOM
        const existingScript = document.querySelector(`script[src="${url}"]`);
        if (existingScript) {
            scriptLoaded = true;
            scriptElement = existingScript as HTMLScriptElement;
            return;
        }

        // Create and load script
        scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = url;
        scriptElement.onload = () => {
            scriptLoaded = true;
        };
        scriptElement.onerror = () => {
            scriptLoaded = false;
            scriptElement = null;
        };

        document.body.appendChild(scriptElement);
        scriptLoaded = true;

        // Don't remove script on cleanup - it should persist across component unmounts
        // The script and custom element registration should remain for the app lifetime
    }, [url, token]);
};
export default useAirtimeScript;
